// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductCard_card__187sV","status":"ProductCard_status__Lfv81","img":"ProductCard_img__3Ieho","name":"ProductCard_name__1gdZZ","price":"ProductCard_price__34xye"};